<template>
  <div id="tradeBithumb">
    <span class="size12px">- 매수/매도 최근거래금액합계 및 정렬 / 금액단위 만원 / 메이저 제외</span>
    <sorted-table
      :values="values"
      ascIcon="<i class='el-icon-caret-top'></i>"
      descIcon="<i class='el-icon-caret-bottom'></i>"
      sort="retMoneySort3m"
      dir="desc"
      class="type3"
    >
      <thead slot="head">
        <th>
          <input
            type="url"
            v-model="searching"
            v-on:input="fnSearch"
            size="2"
            style="text-transform: uppercase;"
          />
        </th>
        <th style="cursor:pointer; width: 4em;">
          <sort-link name="retPriceSort" class="link">가격</sort-link>
        </th>
        <th style="cursor:pointer; width: 4rem;">
          <sort-link name="retMoneySort3m" class="link">3분</sort-link>
        </th>
        <th style="cursor:pointer; width: 4rem;">
          <sort-link name="retMoneySort5m" class="link">5분</sort-link>
        </th>
        <th style="cursor:pointer; width: 4rem;">
          <sort-link name="retMoneySort10m" class="link">10분</sort-link>
        </th>
        <th style="cursor:pointer; width: 4rem;">
          <sort-link name="retMoneySort30m" class="link">30분</sort-link>
        </th>
      </thead>
      <tbody slot="body" slot-scope="sort">
        <tr
          v-for="row in sort.values"
          :key="row.id"
          @click.prevent="onClickModalView(row.title, row.market, row.retPriceSort)"
          style="cursor:pointer;"
        >
          <td class="coinName">
            <div>{{ row.market }}</div>
            <div class="size12px font999">{{ row.marketName }}</div>
            <span class="size11px font999" style="color:red" v-show="row.retIn === 0">입금X</span>
            <span class="size11px font999" style="color:red" v-show="row.retOut === 0">출금X</span>
          </td>
          <td class="num tah" ref="{{ row.retPriceSort }}">
            <span v-html="row.retPrice"></span>
          </td>
          <td class="num tah" ref="{{ row.retMoneySort3m }}">
            <div v-html="row.retMoney3m"></div>
            <div v-html="row.retPrice3m"></div>
          </td>
          <td class="num tah" ref="{{ row.retMoneySort5m }}">
            <div v-html="row.retMoney5m"></div>
            <div v-html="row.retPrice5m"></div>
          </td>
          <td class="num tah" ref="{{ row.retMoneySort10m }}">
            <div v-html="row.retMoney10m"></div>
            <div v-html="row.retPrice10m"></div>
          </td>
          <td class="num tah" ref="{{ row.retMoneySort30m }}">
            <div v-html="row.retMoney30m"></div>
            <div v-html="row.retPrice30m"></div>
          </td>
        </tr>
      </tbody>
    </sorted-table>
    <modalview
      v-if="isModalView"
      @close="isModalView = false"
      :coinSite="coinSite"
      :coinName="coinName"
      :coinPrice="coinPrice"
      :coinPriceUpbit="coinPriceUpbit"
      :coinPriceBithumb="coinPriceBithumb"
      :coinPriceCoinone="coinPriceCoinone"
    />
  </div>
</template>

<script>
import modalview from './modal_view.vue'
export default {
  name: 'tradeBithumb',
  components: { modalview },
  data () {
    return {
      searching: '',
      values: [],
      isModalView: false,
      coinSite: {},
      coinName: {},
      coinPrice: {},
      coinPriceUpbit: {},
      coinPriceBithumb: {},
      coinPriceCoinone: {}
    }
  },
  methods: {
    fetchData: function (coinName) {
      this.$axios
        .get('https://wisebody.co.kr/api/getBithumb_trade.php', {
          params: {
            coinName: coinName
          }
        })
        .then(res => {
          if (res.status === 200) {
            this.$root.$refs.H.lastUpdateDate = res.data.WDATE
            this.$root.$refs.MENU.TCAP = res.data.TCAP
            this.$root.$refs.MENU.TPER = res.data.TPER
            this.$root.$refs.MENU.TBTC = res.data.TBTC
            this.$root.$refs.MENU.TBTCPER = res.data.TBTCPER
            this.$root.$refs.MENU.usd_naver_top = res.data.AUSD_TOP
            this.$root.$refs.F.usd_naver = res.data.AUSD
            this.$root.$refs.F.usdt = res.data.AUSDT
            if (res.data.TOTAL === 0) {
              this.values = []
            } else {
              this.values = res.data.list
            }
          } else {
            console.log('Server Error')
          }
        })
        .catch(e => {
          console.error(e.message)
        })
    },
    onClickModalView: function (coinSite, coinName, coinPrice, coinPriceUpbit, coinPriceBithumb, coinPriceCoinone) {
      this.coinSite = coinSite
      this.coinName = coinName
      this.coinPrice = coinPrice
      this.coinPriceUpbit = coinPriceUpbit
      this.coinPriceBithumb = coinPriceBithumb
      this.coinPriceCoinone = coinPriceCoinone
      this.isModalView = true
    },
    fnSearch: function (e) {
      this.fetchData(e.target.value.toUpperCase())
    }
  },
  created () {
    this.$root.$refs.M = this
    this.fetchData()
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/trade_bithumb.vue